import Phaser from "phaser";
import { GAME_WIDTH } from "../config";
import { StageId } from "../types";

/** プログレスバーの寸法 */
const BAR_X = 50;
const BAR_Y = 44;
const BAR_WIDTH = 160;
const BAR_HEIGHT = 10;
const BAR_BG_COLOR = 0x333333;
const BAR_FILL_COLOR = 0x00ffcc;

/** ステージ昇格演出の持続時間(ms) */
const STAGE_UP_DURATION = 500;

/** スコア・コンボ・ステージ表示 */
export class HUD {
  private scene: Phaser.Scene;
  private scoreText: Phaser.GameObjects.Text;
  private comboText: Phaser.GameObjects.Text;
  private stageText: Phaser.GameObjects.Text;
  private nextStageText: Phaser.GameObjects.Text;
  private barBg: Phaser.GameObjects.Graphics;
  private barFill: Phaser.GameObjects.Graphics;
  private stageUpText: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;

    // スコア（左上）
    this.scoreText = scene.add.text(16, 12, "SCORE: 0", {
      fontSize: "20px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#ffffff",
    });
    this.scoreText.setDepth(100);

    // コンボ倍率（右上）
    this.comboText = scene.add.text(GAME_WIDTH - 16, 12, "x1.0", {
      fontSize: "20px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#ffdd44",
    });
    this.comboText.setOrigin(1, 0);
    this.comboText.setDepth(100);

    // ステージ表示（2行目左）
    this.stageText = scene.add.text(16, 42, "S1", {
      fontSize: "14px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#00ffcc",
      fontStyle: "bold",
    });
    this.stageText.setDepth(100);

    // プログレスバー背景
    this.barBg = scene.add.graphics();
    this.barBg.setDepth(100);
    this.barBg.fillStyle(BAR_BG_COLOR, 1);
    this.barBg.fillRoundedRect(BAR_X, BAR_Y, BAR_WIDTH, BAR_HEIGHT, 3);

    // プログレスバー前景
    this.barFill = scene.add.graphics();
    this.barFill.setDepth(100);

    // 次ステージ閾値（バー右横）
    this.nextStageText = scene.add.text(BAR_X + BAR_WIDTH + 8, 42, "", {
      fontSize: "11px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#888888",
    });
    this.nextStageText.setDepth(100);

    // ステージ昇格演出テキスト（非表示で待機）
    this.stageUpText = scene.add.text(GAME_WIDTH / 2, 120, "", {
      fontSize: "32px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#00ffcc",
      fontStyle: "bold",
      stroke: "#000000",
      strokeThickness: 4,
    });
    this.stageUpText.setOrigin(0.5, 0.5);
    this.stageUpText.setDepth(200);
    this.stageUpText.setAlpha(0);
  }

  /** 毎フレーム表示更新 */
  update(score: number, comboMult: number, stage: StageId, progressRatio: number, nextScore: number): void {
    this.scoreText.setText(`SCORE: ${score}`);
    this.comboText.setText(`x${comboMult.toFixed(1)}`);
    this.stageText.setText(stage);

    // プログレスバー描画
    this.barFill.clear();
    const fillWidth = Math.max(0, Math.min(BAR_WIDTH, BAR_WIDTH * progressRatio));
    if (fillWidth > 0) {
      this.barFill.fillStyle(BAR_FILL_COLOR, 1);
      this.barFill.fillRoundedRect(BAR_X, BAR_Y, fillWidth, BAR_HEIGHT, 3);
    }

    // 次ステージ閾値の数値
    if (nextScore > 0) {
      this.nextStageText.setText(`→ ${nextScore.toLocaleString()}`);
    } else {
      this.nextStageText.setText("MAX");
    }
  }

  /** ステージ昇格演出 */
  showStageUp(stage: StageId): void {
    this.stageUpText.setText(`STAGE UP!  ${stage}`);
    this.stageUpText.setAlpha(1);
    this.stageUpText.setScale(0.5);

    this.scene.tweens.add({
      targets: this.stageUpText,
      scaleX: 1,
      scaleY: 1,
      alpha: 0,
      duration: STAGE_UP_DURATION,
      ease: "Cubic.easeOut",
    });
  }
}
